import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginConfirmationCodeComponent } from './pages/login-confirmation-code/login-confirmation-code.component';
import { RegistrationPhoneComponent } from './pages/registration-phone/registration-phone.component';
import { RegistrationConfirmationCodeComponent } from './pages/registration-confirmation-code/registration-confirmation-code.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import {RecoveryPasswordComponent} from './pages/recovery-password/recovery-password.component';
import {RecoveryPasswordConfirmationCodeComponent} from './pages/recovery-password-confirmation-code/recovery-password-confirmation-code.component';
import {RecoveryPasswordPhoneComponent} from './pages/recovery-password-phone/recovery-password-phone.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/confirmation-code',
        component: LoginConfirmationCodeComponent
      },
      {
        path: 'registration',
        component: RegistrationPhoneComponent
      },
      {
        path: 'registration/confirmation-code',
        component: RegistrationConfirmationCodeComponent
      },
      {
        path: 'registration-details',
        component: RegistrationComponent,
      },
      {
        path: 'recovery-password',
        component: RecoveryPasswordPhoneComponent,
      },
      {
        path: 'recovery-password-details',
        component: RecoveryPasswordComponent,
      },
      {
        path: 'recovery-password/confirmation-code',
        component: RecoveryPasswordConfirmationCodeComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
